import { render, staticRenderFns } from "./user-variables.vue?vue&type=template&id=49e98cdc&scoped=true&"
import script from "./user-variables.vue?vue&type=script&lang=js&"
export * from "./user-variables.vue?vue&type=script&lang=js&"
import style0 from "./user-variables.vue?vue&type=style&index=0&id=49e98cdc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e98cdc",
  null
  
)

export default component.exports